import { Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { findSelectedSection } from '@intercom/composer-ember/lib/helpers/selection';
export default class SelectedSectionNodeDecorationPlugin extends Plugin {
  constructor(composer) {
    super({
      state: {
        init: () => ({
          deco: DecorationSet.empty
        }),
        apply(tr, value, _oldState, _newState) {
          let data = tr.getMeta(this);
          if (data) {
            return data;
          }
          return value;
        }
      },
      props: {
        handleClickOn(view, _pos, _node, _nodePos, event, _direct) {
          if (event.target?.classList.contains('embercom-prosemirror-composer-section')) {
            let plugin = this;
            view.dispatch(view.state.tr.setMeta(this, {
              deco: plugin.decorations(view.state)
            }));
            composer.state.isSectionSelected = true;
            return false;
          }
          composer.state.isSectionSelected = false;
          view.dispatch(view.state.tr.setMeta(this, {
            deco: DecorationSet.empty
          }));
          return false;
        },
        decorations(state) {
          return this.getState(state).deco;
        }
      }
    });
  }
  decorations(state) {
    let from;
    let to;
    let section = findSelectedSection(state);
    if (!section) {
      return;
    }
    let resolved = state.doc.resolve(section.start);
    from = resolved.before();
    to = resolved.after();
    let decoration = Decoration.node(from, to, {
      class: 'embercom-prosemirror-composer-selected-section'
    });
    return DecorationSet.create(state.doc, [decoration]);
  }
}